export default __webpack_public_path__ + "static/media/9_the_trumpet.2d2a43a9.png";